import React from "react";
import { Link } from "react-router-dom";

const RightLeague = () => {
  return (
    <div className="sticky-top">
      <div className="mt-2 mb-3">
        <div className="card card-curve pt-3 pb-3 ">
          <span className="float-left">
            <Link to="/league/17728">
              {" "}
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images/soccer/leagues/15/1007.png"
                  width="30px"
                  alt=""
                />{" "}
                {"  "}
                Indian Super League
              </button>
            </Link>{" "}
            <br />
            <Link to="/league/17420">
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images/soccer/leagues/8/8.png"
                  width="30px"
                  alt=""
                />{" "}
                {"  "}
                Premier League
              </button>
            </Link>
            <br />
            <Link to="/league/17480">
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images/soccer/leagues/564.png"
                  width="30px"
                  alt=""
                />{" "}
                {"  "}
                La Liga
              </button>
            </Link>
            <br />
            <Link to="/league/17361">
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images/soccer/leagues/82.png"
                  width="30px"
                  alt=""
                />
                {"  "}
                Bundesliga
              </button>
            </Link>
            <br />
            <Link to="/league/17488">
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images//soccer/teams/0/384.png"
                  width="30px"
                  alt=""
                />{" "}
                {"  "}
                Serie A
              </button>
            </Link>
            <br />
            <Link to="/league/17160">
              <button className="btn btn-primary">
                <img
                  src="https://cdn.sportmonks.com/images/soccer/leagues/301.png"
                  width="30px"
                  alt=""
                />{" "}
                {"  "}
                Ligue
              </button>
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default RightLeague;
